<template>
  <div class="probono">
    <HeaderComponent />

    <main class="content">
<!--      <div class="image-container">-->
<!--        <img src="" alt="Imagine social cultural" class="social-image">-->
<!--      </div>-->
      <h1>ProBono</h1>

      <div class="mission-statement">
        <p>La cabinetul nostru, credem cu tărie că sprijinul psihologic ar trebui să fie accesibil tuturor, indiferent de situația financiară. De aceea, am creat un program dedicat pentru servicii pro bono, prin care oferim sprijin gratuit persoanelor care se confruntă cu dificultăți financiare și au nevoie urgentă de consiliere sau terapie.</p>
      </div>

      <div>
        <div class="eligibility">
          <h3>Serviciile pro bono se adresează:</h3>
          <ul>
            <li>persoanelor cu venituri reduse sau momentan fără surse de venit.</li>
            <li>părinților care doresc să sprijine dezvoltarea emoțională a copiilor, dar întâmpină dificultăți financiare.</li>
            <li>persoanelor afectate de situații de criză, cum ar fi pierderea unui loc de muncă, un eveniment traumatic sau alte circumstanțe excepționale.</li>
          </ul>
        </div>

        <div class="how-it-works">
          <h3>Cum funcționează?</h3>
          <ul>
            <li>Programul este limitat la un număr stabilit de sesiuni gratuite, în funcție de resursele disponibile.</li>
            <li>Menționați că aveți nevoie de servicii pro bono (gratuite) în momentul în care faceți programarea</li>
            <li>Confidențialitatea și respectul pentru fiecare beneficiar sunt priorități absolute</li>
          </ul>
        </div>

        <div class="why-section">
          <h3>De ce facem asta?</h3>
          <p>Ne dorim să contribuim la o societate mai sănătoasă și mai empatică, oferind sprijin celor care, în momente dificile, nu pot accesa serviciile psihologice necesare.</p>
        </div>
      </div>
    </main>

    <FooterComponent />
  </div>
</template>

<script>
  import HeaderComponent from "../components/HeaderComponent.vue";
  import FooterComponent from "../components/FooterComponent.vue";

  export default {
    name: 'Probono',
    components: {FooterComponent, HeaderComponent},
    data () {
      return {
        services: [
          {
            name: 'Consiliere psihologică individuală',
            duration: '50-60 min.',
            price: '180-200 Ron'
          },
          {
            name: 'Terapie de cuplu',
            duration: '60 min.',
            price: '230 Ron'
          },
          {
            name: 'Evaluare psihologică și intervenție primară copii și adolescenți',
            duration: '50 min.',
            price: '180 Ron'
          },
          {
            name: 'Evaluare clinică adulți',
            duration: '60 min',
            price: '200 Ron'
          },
          {
            name: 'Evaluare psihologică pentru Comisia de Evaluare a Persoanelor Adulte cu Handicap și întocmirea raportului psihologic (se poate realiza și la domiciliul bolnavului)',
            duration: '60 min',
            price: '250 Ron'
          },
          {
            name: 'Evaluare psihologică pentru întocmirea dosarului de CES la copii și întocmirea raportului psihologic',
            duration: '60 min',
            price: '200 Ron'
          },
          {
            name: 'Evaluare psihologică în vederea obținerii permisului de port armă letală și eliberarea avizului psihologic',
            duration: '60 min',
            price: '300 Ron'
          },
          {
            name: 'Evaluare psihologică în vederea obținerii permisului de port armă neletală și eliberarea avizului psihologic',
            duration: '60 min',
            price: '250 Ron'
          },
          {
            name: 'Evaluare psihologică în vederea prelungirii permisului de port armă letală și eliberarea avizului psihologic',
            duration: '60 min',
            price: '300 Ron'
          },
          {
            name: 'Evaluare psihologică în vederea prelungirii permisului de port armă neletală și eliberarea avizului psihologic',
            duration: '60 min',
            price: '250 Ron'
          }
        ]
      }
    }
  }
</script>

<style lang="scss">
  $primary-color: #263f7a;
  $hover-color: #1a2b53;
  $light-bg: #d2d6e8;
  $border-color: #ddd;

  @media screen and (min-width: 0px) {
    .probono {
      font-weight: 200;
      font-size: 22px;
      margin-top: 80px;

      .content {
        max-width: 1000px;
        margin: 40px auto;
        padding: 0 20px 60px;
      }

      .image-container {
        max-width: 600px;
        margin: 0 auto 40px;
        background-color: #f2f2f2;
        text-align: center;
        padding: 40px 0;

        .social-image {
          max-width: 100%;
          height: auto;
        }
      }

      .mission-statement p, .why-section p {
        font-size: 22px;
        line-height: 1.6;
        margin-bottom: 25px;
        text-align: left;
      }

      h1 {
        font-size: 38px;
        margin-bottom: 20px;
        color: $primary-color;
        text-align: center;
      }

      h3 {
        font-size: 26px;
        margin: 30px 0 15px;
        color: $primary-color;
        text-align: left;
      }

      ul {
        padding-left: 20px;
        margin-bottom: 30px;
        text-align: left;

        li {
          font-size: 22px;
          line-height: 1.6;
          margin-bottom: 10px;
          text-align: left;
        }
      }

      .mission-statement p {
        font-size: 22px;
      }

      .eligibility, .how-it-works, .why-section {
        margin-bottom: 30px;
      }

      .why-section {
        padding-bottom: 20px;
      }
    }
  }
</style>